import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "formatNumber",
})
export class FormatNumberPipe implements PipeTransform {

    transform(input: string) {

        var inputNumber = Number(input);

        if (inputNumber > 1000) {
            var thousands = inputNumber / 1000;
            thousands = Math.round(thousands * 10) / 10;
            return `${thousands}k`;
        }

        return input;
    }
}
